import FormControlLabel, { FormControlLabelProps } from "@material-ui/core/FormControlLabel";
import MUICheckbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import React, { FC } from "react";
import { withStyles } from "@material-ui/core/styles";

const CustomColorCheckbox = withStyles({
  root: {
    color: "#9E9E9E",
    "&$checked": {
      color: "#FF7262",
    },
  },
  checked: {},
})((props: CheckboxProps) => <MUICheckbox color="default" {...props} />);

const CheckBox: FC<Omit<FormControlLabelProps, "control">> = ({ ...props }) => {
  return (
    <FormControlLabel
      {...props}
      control={<CustomColorCheckbox checked={props.checked} onChange={props.onChange} name={props.name} />}
    />
  );
};

export default CheckBox;
